import {Component, Optional} from '@angular/core';
import {NbWindowRef} from '@nebular/theme';
import {BaseComponent} from '../base.component';

/**
 * Общий скелет попапа адреса (admin / customer): поле Dadata → `address`, `selected()`,
 * `@Optional() windowRef`. Стратегия `onSubmit` — за подклассом (admin закрывает окно
 * geo-объектом, customer POST'ит `/delivery-address` + reload). Шаблон/стили — тоже за
 * подклассом (admin — `nb-card`-обёртка, customer — плоский div). Подклассам не нужен
 * свой конструктор: они наследуют этот (вместе с DI `windowRef`).
 */
@Component({template: ''})
export abstract class PopupAddressBaseComponent extends BaseComponent {
  protected address = '';

  constructor(@Optional() protected readonly windowRef: NbWindowRef) {
    super();
  }

  /** Извлекает `unrestricted_value` из события Dadata в `address`. Подкласс может переопределить (super + geo). */
  onSelect(event: unknown): void {
    this.address = (event !== null && typeof event === 'object' && 'unrestricted_value' in event)
      ? (event as { unrestricted_value: string }).unrestricted_value
      : '';
    this.cdr.detectChanges();
  }

  selected(): boolean {
    return this.address.length > 0;
  }

  abstract onSubmit(): void;
}
